export class ThemeTokensHelper {
  public static toCSSVars<T extends readonly string[]>(tokens: T): Record<T[number], string> {
    return tokens.reduce(
      (acc, token) => {
        acc[token as T[number]] = `var(--${token})`
        return acc
      },
      {} as Record<T[number], string>,
    )
  }
}
